import ErrorBoundary from 'src/components/ErrorBoundary';
import { SearchProductContextProvider } from 'src/sections/search_products/SearchProductContext';
import SearchProductPageLayout from 'src/sections/search_products/SearchProductPageLayout';

const SearchProducts = () => (
  <ErrorBoundary>
    <SearchProductContextProvider>
      <SearchProductPageLayout />
    </SearchProductContextProvider>
  </ErrorBoundary>
);

export default SearchProducts;
